/**
 * This service is in charge of saving states on multiple page
 * especially on pages with map for now (lsr, nrp, npr)
 */
angular.module(NgAppName).service('handleNoReloadPageService', ['$timeout', function($timeout) {

	this.run = function(showTooltip) {
		//Global variable for Guest
		if (typeof G !== "undefined" && G) {
			G = false;
		}

		var $guestItems = angular.element(document.querySelectorAll('._guest_item'));
		var $registeredUsers = angular.element(document.querySelectorAll('._registered_user_item'));

		if ($guestItems.length) {
			angular.forEach($guestItems, function(item) {
				angular.element(item).remove();
			});
		}

		if ($registeredUsers.length) {
			// just for desktop
			if (window.Tracker) {
				var trackerObj = new Tracker();
			}

			angular.forEach($registeredUsers, function(item) {
				item.show();
				if (showTooltip) {
					var notif = item.querySelector('.members_center_notification');
					if (notif) {
						notif.show();
						$timeout(function() {
							notif.hide();
						}, 5000);
					}
				}

				if (trackerObj) {
					var itemsToTrack = angular.element(item.querySelectorAll('[data-track-link="true"]'));
					angular.forEach(itemsToTrack, function(itemToTrack) {
						trackerObj.addTrackClick(itemToTrack);
					});
				}
			});
		}
	};
}]);
